/**
 * #2969: the answers the /renew wizard shows but does not offer. A family
 * that already exists does not pick its own renewal year; the server seeds it
 * and only TRF changes it (#2737). One definition, read by the wizard (which
 * renders these as `readOnly`) and by the staff question picker (which must
 * never offer one as something the family has to fix), so the two cannot drift.
 *
 * Keys are `section.field`, the same shape `FlaggableField.key` carries.
 */
export const RENEWAL_READ_ONLY_FIELDS: ReadonlySet<string> = new Set(['intake.application_type']);

/** Is this answer read-only on a renewal? */
export function isRenewalReadOnlyField(section: string, key: string): boolean {
  return RENEWAL_READ_ONLY_FIELDS.has(`${section}.${key}`);
}
